/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.14.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import { ETextBlockStatus } from '../../components/common/TextBlockStatus/textBlockStatusTypes';
import { WIZARD_STORAGE_CLEAR_STEPS } from '../../modules/wizard/wizardConstants';
import { TWizardChangeLockActions } from './types/wizardChangeLockActionTypes';
import { IWizardChangeLockValidation } from './types/wizardChangeLockTypes';
import {
    initWizardChangeLockState,
    WIZARD_CHANGE_LOCK_SET_PARAMS,
    WIZARD_CHANGE_LOCK_SET_STEP_VALID,
} from './wizardChangeLockConstant';

export interface IWizardChangeLockLockDateParameters {
    dateCanNow: boolean;
    dateFrom: string;
    dateFromEnd: string;
    dateTo: string;
    dateToEnd: string;
    dateToStart: string;
}

export interface IWizardChangeLockReducer {
    dateFrom: string;
    dateTo: string;
    isOnlineCheckProceeded: boolean;
    isUnlockSubscribers: boolean;
    lockParameters: IWizardChangeLockLockDateParameters;
    maxLockingPeriod: number;
    orderCheckResult: IWizardChangeLockOrderResult;
    removedSubscribers: number[];
    subscriberIds: number[];
    validation: IWizardChangeLockValidation;
}

export interface IWizardChangeLockOrderSubscriber {
    subsId: number;
    charge: number;
    msisdn: string;
    errorMessage: string;
    status: Exclude<ETextBlockStatus, ETextBlockStatus.CHANGE>;
}

export interface IWizardChangeLockOrderResult {
    sumCharge: number;
    orderSubs: IWizardChangeLockOrderSubscriber[];
}

const wizardChangeLockReducer: Reducer<IWizardChangeLockReducer, TWizardChangeLockActions> = (
    state = initWizardChangeLockState,
    action: TWizardChangeLockActions,
) =>
    produce(state, (draft) => {
        switch (action.type) {
            case WIZARD_CHANGE_LOCK_SET_PARAMS:
                Object.assign(draft, { ...draft, ...action.payload });
                break;
            case WIZARD_CHANGE_LOCK_SET_STEP_VALID:
                draft.validation.isValid = action.payload.isStepValid;
                draft.validation.error = action.payload.validateError;
                break;

            case WIZARD_STORAGE_CLEAR_STEPS:
                Object.assign(draft, initWizardChangeLockState);
                break;
        }
    });

export default wizardChangeLockReducer;
